<template>
  <div class="modal modalShown">
    <div class="schemeImg">
      <div
        :style="{
          'background-image': `url(${require('@/assets/images/CycleRoute/mapOverview.jpg')})`,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImgModal",
  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.modalShown {
  display: block;
  z-index: 40;
  top: 150px;
}

.schemeImg {
  width: 100%;
  height: 62vh;

  div {
    width: 100%;
    height: 100%;

    background-size: cover;
    background-repeat: none;
  }
}
</style>
